
import { defineComponent, ref, reactive, inject, computed, onMounted } from "vue";
import { getConstructors } from "@/api/http";

const mockData = [
    { id: 1, car_code: "粤S55555", follower_name: "张三", follow_date: "2026-06-28 14:30", follow_count: 3, content: "客户考虑中，报价已发送，等待回复。商业险约3500元，交强险665元。" },
    { id: 2, car_code: "粤B88888", follower_name: "李四", follow_date: "2026-06-29 09:15", follow_count: 1, content: "首次联系，了解客户需求，推荐全险方案。客户表示明天到店详谈。" },
];

export default defineComponent({
    name: "FollowRecord",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(["跟进记录"]);

        const headClass = inject("headClass");
        const loading = ref(false);
        const pageSize = ref(10);
        const currentPage = ref(1);
        const followerList = ref([] as Array<any>);
        const searchParams = reactive({ follower_id: "", follow_time: [] as any, search: "" });

        const pagedData = computed(() => {
            const start = (currentPage.value - 1) * pageSize.value;
            return mockData.slice(start, start + pageSize.value);
        });

        const handleSizeChange = (size: number) => { pageSize.value = size; currentPage.value = 1; };
        const handleCurrentChange = (page: number) => { currentPage.value = page; };

        onMounted(() => {
            getConstructors({}).then((res: any) => {
                followerList.value = res?.content?.staff || [];
            });
        });

        return { loading, headClass, pageSize, currentPage, followerList, searchParams, mockData, pagedData, handleSizeChange, handleCurrentChange };
    },
});
